import React, {useEffect, useState} from "react";


export const LoginButton = ({clientCtx, text = undefined}) => {

    let [lang, setLang] = useState('en');
    let [ageComparator, setAgeComparator] = useState('');
    let [scopes, setScopes] = useState('');

    useEffect(() => {
        setLang(localStorage.getItem('i18nextLng'));
        setAgeComparator(localStorage.getItem('ageComparator'));
        setScopes(localStorage.getItem('scopes'));
    })

    const translations = {
        en: 'Log in',
        et: 'Logi sisse',
        lv: 'Pieslēgties',
    }

    const makeLoginRequest = () => {
        let headers = new Headers();
        headers.set('Authorization', 'Basic ' + btoa(clientCtx.client.clientId + ":" + clientCtx.client.basicAuthPass));
        headers.append('Content-Type', 'application/x-www-form-urlencoded');

        const urlSearchParams = {
            'scope': scopes ? scopes : 'openid',
            'response_type': 'code',
            'redirect_uri': global.demoConfig.OIDC_REQUEST_REDIRECT_URI,
            'state': 'af0ifjsldkj',
            'code_challenge_method': 'S256',
            'nonce': 'n-0S6_WzA2Mj',
            'client_id': clientCtx.client.clientId,
            'code_challenge': 'hKpKupTM391pE10xfQiorMxXarRKAHRhTfH_xkGf7U4'
        };
        if (ageComparator) {
            urlSearchParams['age_comparator'] = parseInt(ageComparator);
        }

        fetch('/par', {
            method: 'POST',
            headers: headers,
            body: new URLSearchParams(urlSearchParams)
        }).then((response) => response.json())
            .then((responseJson) => {
                const splitRequestUri = responseJson['request_uri'].split(":");
                const requestUri = splitRequestUri.pop();

                redirectToAuthorize(requestUri);
            })
            .catch((error) => {
                console.error(error);
            });
    }

    const redirectToAuthorize = (requestUri) => {
        window.location.href = '/authorize?client_id=' + clientCtx.client.clientId + '&request_uri=urn:ietf:params:oauth:request_uri:' + requestUri;
    }


    return <button className='btn'
                   style={{backgroundColor: clientCtx.client.buttonColor}}
                   onClick={makeLoginRequest}>{text ? text : translations[lang]}
    </button>
}
